<template>
  <el-form
    class="customers-locations-search-form"
    size="small"
    label-position="top"
  >
    <el-row
      :gutter="20"
      type="flex"
    >
      <el-col :span="8">
        <el-form-item>
          <span slot="label">{{
            $t('customersLocationsManagement.search.id')
          }}</span>
          <el-autocomplete
            v-model="formData.id"
            value-key="label"
            clearable
            :fetch-suggestions="
              (text, cb) => {
                searchCustomers({ text, cb, field: 'name' });
              }
            "
            :trigger-on-focus="false"
            @select="searchCustomersLocations"
            @change="emptySelectedCustomers"
          >
            <template slot-scope="{ item }">
              <AutocompleteItem :item="item" />
            </template>
          </el-autocomplete>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item>
          <span slot="label">{{
            $t('customersLocationsManagement.search.name')
          }}</span>
          <el-autocomplete
            v-model="formData.name"
            value-key="label"
            clearable
            :fetch-suggestions="
              (text, cb) => {
                searchCustomers({ text, cb, field: 'name' });
              }
            "
            :trigger-on-focus="false"
            @select="searchCustomersLocations"
            @change="emptySelectedCustomers"
          >
            <template slot-scope="{ item }">
              <AutocompleteItem :item="item" />
            </template>
          </el-autocomplete>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import AutocompleteItem from '@/components/AutocompleteItem.vue';

  import { customersApi } from '@/api';

  const initialFormData = {
    name: '',
    id: null,
  };

  export default {
    name: 'CustomersLocationsSearch',
    components: {
      AutocompleteItem,
    },
    data() {
      return {
        formData: { ...initialFormData },
      };
    },
    computed: {
      ...mapGetters(['forms']),
    },
    methods: {
      ...mapActions(['updateForm']),
      async searchCustomers({ text, cb, field }) {
        if (text.length >= 3) {
          const response = await customersApi.autocompleteFetch(
            field,
            text,
            false,
            true
          );
          const customers = response.data.map((a) => ({
            value: `${a.id}`,
            label: `${a.id} ${a.name}`,
            name: a.name,
          }));
          cb(customers);
        } else {
          cb([]);
        }
      },
      searchCustomersLocations(item) {
        this.formData.id = item.value;
        this.formData.name = item.name;
        this.updateForm({
          formKey: 'customersLocations',
          formData: this.formData,
        });
        this.$emit('handle-customers-locations-list-update');
      },
      emptySelectedCustomers(text) {
        if (text === '') {
          this.formData.id = null;
          this.formData.name = null;
          this.updateForm({
            formKey: 'customersLocations',
            formData: this.formData,
          });
          this.$emit('handle-customers-locations-list-update');
        }
      },
    },
    watch: {
      'forms.customersLocations': {
        handler(data) {
          this.formData = { ...data };
        },
        deep: true,
      },
    },
    created() {
      this.formData = Object.keys(this.forms.customersLocations).length
        ? { ...this.forms.customersLocations }
        : { ...initialFormData };
    },
  };
</script>

<style lang="scss" scoped>
  .customers-locations-search-form {
    padding-bottom: 20px;
    min-height: $filter-form-min-height;

    .el-form-item {
      &__label {
        color: $--color-text-regular;
        min-height: $filter-label-min-height;
      }

      &--small {
        .el-form-item {
          &__label {
            padding-bottom: 15px;
            line-height: 1;
            min-height: $filter-label-min-height;
          }
        }
      }

      .el-autocomplete {
        width: 100%;
      }
    }
  }
</style>
